import { customElement } from 'lit/decorators.js'
import { html } from 'lit'
import { map } from 'lit/directives/map.js'
import { live } from 'lit/directives/live.js'
import { VariantFilterBaseExtended } from 'components/discovery/variant-filter/typing/shared-types.js'

@customElement('csc-variant-filter-swatches')
export class VariantFilterSwatches extends VariantFilterBaseExtended {

  override render() {
    return html`
      <cse-form-field>
        <cse-label slot="label">
          ${this.attribute.name}
        </cse-label>

        <cse-group class="swatch-group" column-gap="05" alignment="center">
          ${map(this.visibleOptions, (option) => html`
            <cse-swatch
              variant="text"
              size="large"
              ?selected="${live(!!option.selected)}"
              ?out-of-stock="${this.shouldBeCrossedOut(option)}"
              tooltip="${this.handleToolTipMessage(option)}"
              @click="${() => this.handleSwatchClick(option)}"
            >
              ${option.name}
            </cse-swatch>
          `)}

          ${this.renderShowMoreLink()}
        </cse-group>
      </cse-form-field>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-variant-filter-swatches': VariantFilterSwatches
  }
}
